import { render, staticRenderFns } from "./PanelBoardShow.vue?vue&type=template&id=4b0ac6a0&"
import script from "./PanelBoardShow.vue?vue&type=script&lang=js&"
export * from "./PanelBoardShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports